import { Box, IconButton, makeStyles, Typography } from "@material-ui/core";
import { FC, useEffect, useState } from "react";
import RemoveIcon from "@material-ui/icons/Remove";
import TooltipPopover from "../../../components/TooltipPopover";
import CustomCard from "../../../components/CustomCard";
import useDisabledOnLoading from "../../../hooks/useDisabledOnLoading";

const useStyles = makeStyles({
  imageInputContainer: {
    position: "relative",
    border: "4px dashed #d6d6d6",
    padding: "30px 20px 20px",
    "& input": {
      width: "100%",
      position: "absolute",
      top: "30px",
      left: 0,
      opacity: 0,
      cursor: "pointer",
    },
  },
  imageInputText: {
    textAlign: "center",
    marginBottom: 25,
  },
});

const ProfileImages: FC<any> = ({ images, onSelectImages, disabled = false, title = "Images" }) => {
  const classes = useStyles();
  const [selectedImages, setSelectedImages] = useState<any>(images);
  const [imagesPreview, setImagesPreview] = useState(images);
  const { disabledStyles } = useDisabledOnLoading(disabled);

  const removeImage = (removedIndex: number) => {
    const images = selectedImages.filter((_: null, index: number) => index !== removedIndex);
    setSelectedImages(images);
  };

  const handleMultipleImages = (e: any) => {
    const selectedNewImages = e.target.files;
    setSelectedImages((prevState: any) => [...prevState, ...selectedNewImages]);
  };

  const handlePreviewImages = (images: any) => {
    const selectedImages: any = [];
    const targetFilesObject = [...images];
    targetFilesObject.map((image) => {
      return selectedImages.push(image instanceof File ? URL.createObjectURL(image) : image);
    });
    setImagesPreview(selectedImages);
  };

  useEffect(() => {
    handlePreviewImages(selectedImages);
    onSelectImages(selectedImages);
  }, [selectedImages]);

  return (
    <CustomCard title={title} width="50%">
      <Box className={classes.imageInputContainer} style={disabledStyles}>
        <input type="file" onChange={handleMultipleImages} multiple accept="image/*" id="upload-image" />
        <Typography variant="body2" className={classes.imageInputText}>
          Drop some images to upload, or click to select one
        </Typography>

        {imagesPreview && imagesPreview.length ? (
          <Box display="flex" flexWrap="wrap">
            {imagesPreview.map((image: any, index: number) => {
              return (
                <Box display="flex" height="200px" width="200px" mb={3} mr={4} key={index}>
                  <img
                    style={{ width: "90%", height: "90%", objectFit: "contain" }}
                    src={image.src ?? image}
                    alt={image.src ?? image}
                  />
                  <TooltipPopover message="Remove Image">
                    <IconButton color="secondary" onClick={() => removeImage(index)}>
                      <RemoveIcon />
                    </IconButton>
                  </TooltipPopover>
                </Box>
              );
            })}
          </Box>
        ) : null}
      </Box>
    </CustomCard>
  );
};

export default ProfileImages;
